import React, { CSSProperties } from 'react';

import { ReactionsBanner } from '@/components/Profile/Content/GetMore/Banner/ReactionsBanner.tsx';
import { BoostsBanner } from '@/components/Profile/Content/GetMore/Banner/BoostsBanner.tsx';
import { PremiumBanner } from '@/components/Profile/Content/GetMore/Banner/PremiumBanner.tsx';

export const GetMore: React.FC = () => {
  return (
    <>
      <div style={centeredContentStyle}>
        <ReactionsBanner />
        <BoostsBanner />
      </div>
      <PremiumBanner />
    </>
  );
};

const centeredContentStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  width: 'calc(100% - 40px)',
  gap: '10px'
};
